module.exports = __webpack_public_path__ + "img/9.8b682c6f.webp";